









































































import { AccountManagementApi, AddPharmacistCommand } from "@/api";
import stateMixin from "@/mixins/state";

export default {
  data() {
    return {
      valid: true,
      fields: {
        emailAddress: "",
        firstName: "",
        middleName: "",
        lastName: "",
        pharmacistType: ""
      },
      rules: {
        emailAddress: [(v: string) => !!v || "E-mailadres is verplicht"],
        firstName: [(v: string) => !!v || "Voornaam is verplicht"],
        lastName: [(v: string) => !!v || "Achternaam is verplicht"],
        pharmacistType: [(v: string) => !!v || "Accounttype is verplicht"]
      }
    };
  },
  name: "PharmacistsAdd",
  mixins: [stateMixin],
  methods: {
    submit: async function(command: AddPharmacistCommand) {
      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new AccountManagementApi();
        try {
          const result = await api.accountManagementAddPharmacist(command);
          this.setState(this.states.COMPLETED);
          (this.$refs.form as HTMLFormElement).reset();
        } catch {
          this.setState(this.states.ERROR);
        }
      }
    }
  }
};
